import { BaseError } from './base-error';

export class ValidationError extends BaseError {
  constructor(message: string) {
    super(message, 'VALIDATION_ERROR', 400);
  }
}

export const isValidationError = (error: unknown): error is ValidationError =>
  error instanceof ValidationError;
